import React, { Component } from 'react';
import { connect }          from 'react-redux';
import { getTranslate }     from 'react-localize-redux';
import storageHelper        from 'helpers/storage.helper';
import moment               from 'moment';
import './index.css';

class AccountDeleted extends Component {

  componentDidMount() {
    storageHelper.destroyStorage();
  }

  render() {
    const { translate } = this.props;

    return (
      <div className="deleted-box">
        <div className="deleted-box--content">
          <div>
            <div className="sent-box--logo" />
            <div className="deleted-box--header">
              <div className="deleted-icon" />
              <span>{ translate('common.account_deleted') }</span>
            </div>
            <div className="deleted-box--img">
              <img src="images/img-001.png" alt='deleted'/>
            </div>
          </div>
          <div className="deleted-box--footer">
            { translate('common.footer_notice', { year: moment().year() }) }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  translate: getTranslate(state.locale)
});

export default connect(mapStateToProps)(AccountDeleted);



// WEBPACK FOOTER //
// ./src/components/common/accountDeleted/index.js